import { PageHead } from "@generalapplications/html-render/react";
import { AboutSections } from "@/app/pages/about/components/AboutSections";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { aboutPage } from "@/content/about";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { PageArticle } from "@generalapplications/ui";

export function AboutPage() {
  const head = pageHead({
    path: routes.about,
    title: aboutPage.seoTitle,
    description: aboutPage.seoDescription,
    imagePath: aboutPage.image,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <PageHero
        headline={aboutPage.headline}
        copy={aboutPage.heroCopy}
        image={aboutPage.image}
      />
      <AboutSections />
    </PageArticle>
  );
}
